import { render, staticRenderFns } from "./IframeModal.vue?vue&type=template&id=3bf0227c&scoped=true"
import script from "./IframeModal.vue?vue&type=script&lang=ts"
export * from "./IframeModal.vue?vue&type=script&lang=ts"
import style0 from "./IframeModal.vue?vue&type=style&index=0&id=3bf0227c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf0227c",
  null
  
)

export default component.exports